import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { ModalsState } from '@app/store/modals/types'

const initialState: ModalsState = {}

const modalsSlice = createSlice({
  name: 'modals',
  initialState,
  reducers: {
    showModal: (state, action: PayloadAction<string>) => {
      state[action.payload] = {
        ...state[action.payload],
        isOpen: true
      }
    },
    closeModal: (state, action) => {
      delete state[action.payload]
    },
  },
})

export const { showModal, closeModal } = modalsSlice.actions
export const modalsReducer = modalsSlice.reducer
